/**
 * @deprecated
 * */
export function shiftIsSeries(shiftId: string) {
  return shiftId.startsWith('shiftseries-');
}
/**
 * @deprecated
 * */
export function shiftIsRotation(shiftId: string) {
  return shiftId.startsWith('shiftrotation-');
}
/**
 * @deprecated
 * */
export function isSingleShift(shiftId: string) {
  return !shiftId.startsWith('shiftrotation-') && !shiftId.startsWith('shiftseries-');
}
